// Config-driven steps for the Onboarding_Form page's tour - same pattern as
// clientOnboardingSteps.js (Home) and clientProfileOnboardingSteps.js (Profile).
// Edit/reorder freely - each step just needs a `target` that matches a
// data-onboarding="..." attribute already tagged in Onboarding_Form.js.
//
// Onboarding_Form.js is one shared component/layout for every form type (Wedding,
// Development, Marketing, Branding) - it exposes the same data-onboarding anchors
// regardless of type, so this single step set covers all of them.
//
// The "first question"/"first answer" steps target whichever field happens to be
// the first one in the first section of the currently visible wizard step (see
// Onboarding_Form.js's `isFirstQuestion` check) - not a specific field name - since
// the form's own fields are backend-driven and differ per type/form.

const clientOnboardingFormSteps = [
  {
    target: '[data-onboarding="client-onboarding-form-list"]',
    title: 'Pick a form',
    description: 'Every form available in this category is listed here. Click one to load it on the right.',
    placement: 'right',
  },
  {
    target: '[data-onboarding="client-onboarding-form-header"]',
    title: "You're filling out",
    description: "This shows the name and description of the form you've selected, so you always know what you're working on.",
    placement: 'bottom',
  },
  {
    target: '[data-onboarding="client-onboarding-form-progress"]',
    title: 'Track your progress',
    description: 'This bar - and the numbered steps below it - shows how many steps this form has and how far along you are.',
    placement: 'bottom',
  },
  {
    target: '[data-onboarding="client-onboarding-form-first-question"]',
    title: 'This is a question',
    description: "Every field on the form asks something like this - here's the first one. Anything marked with a red * is required.",
    placement: 'right',
  },
  {
    target: '[data-onboarding="client-onboarding-form-first-answer"]',
    title: 'This is where you answer',
    description: 'Type, select, or pick your answer here - the input changes depending on what the question is asking for.',
    placement: 'right',
  },
  {
    target: '[data-onboarding="client-onboarding-form-fields"]',
    title: 'Fill in the details',
    description: 'Answer the fields for this step. Anything marked with a red * is required before you can move on.',
    placement: 'top',
  },
  {
    target: '[data-onboarding="client-onboarding-form-actions"]',
    title: 'Move between steps',
    description: 'Use Back and Next to move between steps. On the last step, this button saves your form as a draft.',
    placement: 'top',
  },
];

export default clientOnboardingFormSteps;
